export default __webpack_public_path__ + "static/Grenade-cecc51ada118178308613643dc828377.png";